/**
 * Shopify Customer Password/Invitation Integration
 * 
 * Dieses Script fängt das "Passwort vergessen" Formular ab und
 * sendet die Anfrage an das externe PHP-Script.
 */

(function() {
    'use strict';
    
    // ==========================================
    // KONFIGURATION
    // ==========================================
    
    // URL zu Ihrem Cloudflare Worker
    const HANDLER_URL = 'https://seva-customer.gf-374.workers.dev';
    
    // ==========================================
    // FUNKTIONEN
    // ==========================================
    
    /**
     * Zeigt eine Nachricht im Formular an
     */
    function showMessage(formElement, message, type = 'success') {
        // Alte Nachrichten entfernen
        const oldMessages = formElement.querySelectorAll('.custom-message');
        oldMessages.forEach(msg => msg.remove());
        
        // Neue Nachricht erstellen
        const messageDiv = document.createElement('div');
        messageDiv.className = `custom-message alertBox ${type === 'error' ? 'alertBox--error' : 'alertBox--success'}`;
        messageDiv.innerHTML = `
            <p class="alertBox-message">${message}</p>
        `;
        
        // Nachricht am Anfang des Formulars einfügen
        formElement.insertBefore(messageDiv, formElement.firstChild);
        
        // Zu Nachricht scrollen
        messageDiv.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    
    /**
     * Sendet E-Mail an Handler-Script
     */
    async function handlePasswordRecovery(email, formElement, submitButton) {
        try {
            const response = await fetch(HANDLER_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ email: email })
            });
            
            const data = await response.json();
            
            if (response.ok && data.success) {
                // Erfolg - Einladung gesendet
                showMessage(formElement, data.message, 'success');
                
                // Formular leeren
                const emailInput = formElement.querySelector('input[type="email"]');
                if (emailInput) emailInput.value = '';
                
            } else if (response.status === 404) {
                // Kunde nicht gefunden
                showMessage(formElement, data.message || 'Kein Konto mit dieser E-Mail-Adresse gefunden.', 'error');
                
            } else if (response.status === 400 && data.action === 'already_active') {
                // Konto ist bereits aktiviert
                showMessage(formElement, data.message, 'error');
                
            } else {
                // Allgemeiner Fehler
                showMessage(formElement, data.error || data.message || 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.', 'error');
            }
            
        } catch (error) {
            console.error('Error:', error);
            showMessage(formElement, 'Ein Netzwerkfehler ist aufgetreten. Bitte versuchen Sie es erneut.', 'error');
        } finally {
            // Button wieder aktivieren
            submitButton.disabled = false;
            submitButton.textContent = submitButton.dataset.originalText || 'Absenden';
        }
    }
    
    /**
     * Initialisierung beim Laden der Seite
     */
    function init() {
        // "Konto aktivieren" Formular finden (NICHT das Passwort-Recovery!)
        const activateForm = document.getElementById('activateAccountForm');
        
        if (!activateForm) {
            return; // Kein Formular gefunden
        }
        
        // Submit Event abfangen
        activateForm.addEventListener('submit', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            // E-Mail-Adresse holen
            const emailInput = this.querySelector('input[type="email"]');
            const submitButton = this.querySelector('button[type="submit"], input[type="submit"]');
            
            if (!emailInput || !emailInput.value) {
                showMessage(this, 'Bitte geben Sie eine E-Mail-Adresse ein.', 'error');
                return;
            }
            
            const email = emailInput.value.trim();
            
            // Validierung
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                showMessage(this, 'Bitte geben Sie eine gültige E-Mail-Adresse ein.', 'error');
                return;
            }
            
            // Button deaktivieren während Request läuft
            if (submitButton) {
                submitButton.dataset.originalText = submitButton.textContent || submitButton.value;
                submitButton.disabled = true;
                if (submitButton.tagName === 'BUTTON') {
                    submitButton.textContent = 'Wird verarbeitet...';
                } else {
                    submitButton.value = 'Wird verarbeitet...';
                }
            }
            
            // Request an externes Script senden
            handlePasswordRecovery(email, this, submitButton);
        });
        
        console.log('Customer Password Handler initialized');
    }
    
    // ==========================================
    // INITIALISIERUNG
    // ==========================================
    
    // Warten bis DOM geladen ist
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
    
})();

